export default {
    packages: {
        heading: 'Forfaits',
        description: 'Vous n’avez actuellement aucun abonnement en cours, mais<br> pensez à jeter un oeil sur nos offres <a href="/membres" class="btn-link">membre<a/>'
    },
    infolettres: 'Infolettres',
    infolettresListQc: [
        {
            value: 1,
            title: 'J\'aimerais recevoir les nouvelles de Boires.ca',
            description: 'Tiens-toi informé des nouveaux arrivages en succursale et sur la boutique en ligne de la SAQ.'
        },
        {
            value: 2,
            title: 'Recevoir les nouvelles de produits disponibles en SAQ',
            description: 'Informe-toi avant tout le monde des nouveaux arrivages en Importation Privée. Premier commandé, premier servi!'
        },
        {
            value: 3,
            title: 'Recevoir les nouvelles de produits disponibles en importation privée',
            description: 'Apprends-en davantage sur les humains formidables qui font les vins que tu aimes.'
        },
        {
            value: 4,
            title: 'Recevoir les nouvelles de produits disponibles en boutique',
            description: ''
        },
        {
            value: 5,
            title: 'Recevoir les nouvelles concernant les événements à venir',
            description: ''
        },

    ],
    infolettresListOn: [
        {
            value: 1,
            title: 'J\'aimerais recevoir les nouvelles de Boires.ca',
            description: 'Tiens-toi informé des nouveaux arrivages en succursale et sur la boutique en ligne de la SAQ.'
        },
        {
            value: 2,
            title: 'Recevoir les nouvelles de produits disponibles en LCBO',
            description: 'Informe-toi avant tout le monde des nouveaux arrivages en Importation Privée. Premier commandé, premier servi!'
        },
        {
            value: 3,
            title: 'Recevoir les nouvelles de produits disponibles en commandes privées',
            description: 'Apprends-en davantage sur les humains formidables qui font les vins que tu aimes.'
        },
        {
            value: 4,
            title: 'Recevoir les nouvelles de produits disponibles en boutique',
            description: ''
        },
        {
            value: 5,
            title: 'Recevoir les nouvelles concernant les événements à venir',
            description: ''
        },
    ],
    formRequiredMsg: {
        firstName: 'Votre prénom est obligatoire',
        lastName: 'Votre nom est obligatoire',
        email: 'Votre courriel est obligatoire',
    }
};
